module.exports = __webpack_public_path__ + "static/media/white-logo.82f78568.png";